var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkspaceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#979EA8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1241 12.3189C16.1241 11.8186 16.5297 11.4131 17.0299 11.4131H32.9719C33.4722 11.4131 33.8777 11.8186 33.8777 12.3189V23.5508C33.8777 24.051 33.4722 24.4566 32.972 24.4566H27.3557V25.9059H37.8633C38.3636 25.9059 38.7691 26.3114 38.7691 26.8116V29.8914C38.7691 30.3916 38.3636 30.7972 37.8633 30.7972H12.1387C11.6384 30.7972 11.2329 30.3916 11.2329 29.8914V26.8116C11.2329 26.3114 11.6384 25.9059 12.1387 25.9059H22.4644V24.4566H17.0299C16.5297 24.4566 16.1241 24.051 16.1241 23.5508V12.3189ZM13.8595 38.7682C13.4093 38.7682 13.0443 38.4032 13.0443 37.953L13.0443 32.2464H14.6747L14.6747 37.953C14.6747 38.4032 14.3097 38.7682 13.8595 38.7682ZM35.3267 37.953C35.3267 38.4032 35.6917 38.7682 36.1419 38.7682C36.5922 38.7682 36.9571 38.4032 36.9571 37.953L36.9571 32.2464H35.3267V37.953Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceIcon);
export default __webpack_public_path__ + "static/media/workspaceIcon.5c13ab409ae70b6a67ed2b1608718f39.svg";
export { ForwardRef as ReactComponent };